import { Plus, Trash2, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Field } from "@/components/admin/ui";

const TierEditor = ({ tiers, onChange, testId }) => {
  const update = (i, key, value) => onChange(tiers.map((t, j) => (j === i ? { ...t, [key]: value } : t)));
  const add = () => onChange([...tiers, { pax: (Number(tiers[tiers.length - 1]?.pax) || 0) + 1, price: 0 }]);
  return (
    <div className="space-y-2">
      <div className="grid grid-cols-[72px_1fr_36px] gap-2 text-[11px] uppercase tracking-[0.15em] text-neutral-500">
        <span>Pax</span><span>Total harga (Rp)</span><span />
      </div>
      {tiers.map((t, i) => (
        <div key={i} className="grid grid-cols-[72px_1fr_36px] gap-2">
          <Input type="number" min={1} value={t.pax} onChange={(e) => update(i, "pax", e.target.value)} data-testid={`${testId}-tier-${i}-pax`} />
          <Input type="number" min={0} value={t.price} onChange={(e) => update(i, "price", e.target.value)} data-testid={`${testId}-tier-${i}-price`} />
          <Button type="button" size="icon" variant="ghost" disabled={tiers.length === 1} onClick={() => onChange(tiers.filter((_, j) => j !== i))} data-testid={`${testId}-tier-${i}-remove`}><X /></Button>
        </div>
      ))}
      <Button type="button" size="sm" variant="outline" onClick={add} data-testid={`${testId}-tier-add`}><Plus /> Tambah baris</Button>
    </div>
  );
};

const ModeToggle = ({ value, onChange, testId }) => (
  <div className="inline-flex rounded-full border border-white/10 p-1 text-xs">
    {[["pax", "Harga per orang"], ["tier", "Tabel harga per pax"]].map(([key, label]) => (
      <button key={key} type="button" onClick={() => onChange(key)} data-testid={`${testId}-mode-${key}`}
        className={`rounded-full px-4 py-1.5 transition-colors ${value === key ? "bg-gold text-black" : "text-neutral-400 hover:text-white"}`}>
        {label}
      </button>
    ))}
  </div>
);

export const PackageEditor = ({ pkg, index, onChange, onRemove, canRemove }) => {
  const set = (key, value) => onChange({ ...pkg, [key]: value });
  const ev = (key) => (e) => set(key, e.target.value);
  const tid = `trip-form-pkg-${index}`;
  return (
    <div className="space-y-5 rounded-xl border border-white/10 bg-black/30 p-4 sm:p-5" data-testid={tid}>
      <div className="flex items-center justify-between">
        <p className="text-[11px] uppercase tracking-[0.2em] text-gold">Paket {index + 1}</p>
        {canRemove && <Button type="button" size="sm" variant="ghost" className="text-rose-300" onClick={onRemove} data-testid={`${tid}-remove`}><Trash2 /> Hapus</Button>}
      </div>
      <div className="grid gap-4 sm:grid-cols-3">
        <Field label="Nama paket" className="sm:col-span-3"><Input required minLength={2} value={pkg.name} onChange={ev("name")} placeholder="cth. Tektok - Paket Biasa" data-testid={`${tid}-name`} /></Field>
        <Field label="Durasi (hari)"><Input type="number" min={1} value={pkg.duration_days} onChange={ev("duration_days")} data-testid={`${tid}-duration`} /></Field>
        <Field label="Label durasi" className="sm:col-span-2"><Input value={pkg.duration_label} onChange={ev("duration_label")} placeholder="cth. 2 hari 1 malam" data-testid={`${tid}-duration-label`} /></Field>
      </div>
      <ModeToggle value={pkg.mode} onChange={(v) => set("mode", v)} testId={tid} />
      {pkg.mode === "pax" ? (
        <div className="grid gap-4 sm:grid-cols-3">
          <Field label="Harga per orang (Rp)"><Input type="number" min={0} value={pkg.price_per_person} onChange={ev("price_per_person")} data-testid={`${tid}-price`} /></Field>
          <Field label="Min. peserta"><Input type="number" min={1} value={pkg.min_participants} onChange={ev("min_participants")} data-testid={`${tid}-min`} /></Field>
          <Field label="Maks. peserta"><Input type="number" min={1} value={pkg.max_participants} onChange={ev("max_participants")} data-testid={`${tid}-max`} /></Field>
        </div>
      ) : (
        <div className="grid gap-6 sm:grid-cols-2">
          <TierEditor tiers={pkg.price_tiers} onChange={(v) => set("price_tiers", v)} testId={tid} />
          <div className="space-y-4">
            <Field label="Harga per pax tambahan (Rp)" hint="Untuk peserta melebihi tabel. Isi 0 = rombongan lebih besar diminta menghubungi admin.">
              <Input type="number" min={0} value={pkg.extra_pax_price} onChange={ev("extra_pax_price")} data-testid={`${tid}-extra`} />
            </Field>
            {Number(pkg.extra_pax_price) > 0 && (
              <Field label="Maks. peserta"><Input type="number" min={1} value={pkg.max_participants} onChange={ev("max_participants")} data-testid={`${tid}-max`} /></Field>
            )}
          </div>
        </div>
      )}
      <div className="grid gap-4 sm:grid-cols-2">
        <Field label="Termasuk (1 per baris)"><Textarea rows={4} value={pkg.includes} onChange={ev("includes")} data-testid={`${tid}-includes`} /></Field>
        <Field label="Tidak termasuk (1 per baris)"><Textarea rows={4} value={pkg.excludes} onChange={ev("excludes")} data-testid={`${tid}-excludes`} /></Field>
      </div>
    </div>
  );
};
